import { Injectable } from '@angular/core';
import { I18nService } from 'src/app/service/i18n.service';
import { EnvironmentConfig } from '../../environments/environmentConfig';
import { environment } from 'src/environments/environment';
import { AdobeAnalyticsDigitalDataService } from './adobe-analytics-digitaldata.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdobeAnalyticsService {

  private loadOk:boolean = false;
  currentLang :string;
  trackCustom :string = '';
 

  constructor(
    private i18nService : I18nService,
    private envConfObj: EnvironmentConfig,
    private adobeAnalyticsData: AdobeAnalyticsDigitalDataService,
    public router: Router,
    
    ) {
    this.currentLang = this.i18nService.getCurrentLang();
   }

  canActivate() {
    //get the digital data for each page
  
        // let digitalData = this.adobeAnalyticsData.load()
        // console.log(digitalData)
      
        // if (document.getElementById("adobe-tracking-digital-data")) {
        //   document.getElementById("adobe-tracking-digital-data").remove();
        //   let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData ="+digitalData+" if(_satellite){ _satellite.track(‘track’); }</script>"
        //   $("head").append(element);
        // } else {
        //   let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData ="+digitalData+" if(_satellite){ _satellite.track(‘track’); }</script>"
        //   $("head").append(element);
        // }
        // var script = document.createElement('script');
        // script.src = environment.adobeAnalytics.url;
        // script.id  = "adobe-tracking"
        // if (!document.getElementById("adobe-tracking")) {
        //   $("head").append(script.outerHTML);
        //   console.log('Adobe Analytics Loaded!')
        // }
      
        return true;
    
  }
}


